import { Pipe, PipeTransform } from "@angular/core";
import { OrgShiftStateManagement } from './../store/shift/reducer';
@Pipe({
    name: 'shiftFilter'
})

export class ShiftFilterPipe implements PipeTransform{
    constructor(
        private shiftStore: OrgShiftStateManagement
         ){

    }
      transform(obj:any,arg1:string) {
          let shifts = this.shiftStore.get();
          if(shifts!= undefined && shifts.length>0){
            let filterd = shifts.filter(id=> id.shiftID==obj);
            if(filterd && filterd[0] && filterd[0][arg1])  return filterd[0][arg1];
            else return '---';
          }
      }
}